import React, { useEffect, useState } from 'react';
import FramePlayer from '../utils/FramePlayer';
import anime from 'animejs';
import '../css/common.css';
import '../css/button.css';
import ImageButton from '../utils/ImageButton';
import lang from '../lang.json';

const Module3d = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module3d;

    const [musicPlaying, setMusicPlaying] = useState(false);
    const [audio, setAudio] = useState();
    const [cursorPos, setCursorPos] = useState(0);

    const [currentChoices, setCurrentChoices] = useState([]);
    const [audioMini, setAudioMini] = useState();
    const [cursorPosMini, setCursorPosMini] = useState(0);
    const [miniPianoWidth, setMiniPianoWidth] = useState(0);

    const [showRect, setShowRect] = useState(false);

    useEffect(() => {
        let audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module3d.mp3");
        audio.pause();
        setAudio(audio);
        setMusicPlaying(false);
    }, []);

    function play() {
        audio.play();
        setMusicPlaying(true);
    }

    function pause() {
        audio.pause();
        setMusicPlaying(false);
    }

    function reset() {
        audio.currentTime = 0;
        pause();
    }

    function playMini() {
        if (currentChoices.length == 0) {
            return;
        }
        if (audioMini) {
            audioMini.currentTime = 0;
            audioMini.pause();
        }
        //Get image width
        let img = document.getElementById("ImageMiniPiano");
        setMiniPianoWidth(img.clientWidth);
        //Init the audio
        let audio = new Audio(process.env.PUBLIC_URL + `/assets/sounds/module3d_${getChoix()}.mp3`);
        audio.play();
        setAudioMini(audio);
    }

    function resetMini() {
        setCursorPosMini(0);
        audioMini.currentTime = 0;
        audioMini.pause();
    }

    function eraseMini() {
        resetMini();
        setCurrentChoices([]);
    }

    function backMini() {
        //Delete last elem of choices
        resetMini();
        if (currentChoices.length > 0) {
            setCurrentChoices(currentChoices.slice(0, -1));
        }
    }

    function getChoix() {
        if (currentChoices.length == 0) {
            return "choix0";
        } else {
            return "choix" + currentChoices.join("");
        }
    }

    useEffect(() => {
        setInterval(() => {
            if (audio && musicPlaying) {
                let c = audio.currentTime === 0 ? 0 : Math.min(audio.currentTime / audio.duration * 650 + 5, 650);
                setCursorPos(c);
            }
        }, 30);
    }, [audio, musicPlaying]);

    useEffect(() => {
        setInterval(() => {
            if (audioMini && !audioMini.paused) {
                //console.log(audioMini.currentTime / audioMini.duration * miniPianoWidth);
                let c = audioMini.currentTime === 0 ? 0 : Math.min(audioMini.currentTime / audioMini.duration * miniPianoWidth + 6, miniPianoWidth);
                setCursorPosMini(c);
            }
        }, 30);
    }, [audioMini, miniPianoWidth]);

    useEffect(() => {
        var tl = anime.timeline({});
        tl.add({
            targets: '#circle2',
            r: 500,
            duration: 6200,
            easing: 'easeOutElastic(1, .8)',
        }, '0')
            .add({
                targets: '#circle1',
                r: 500,
                duration: 6000,
                easing: 'easeOutElastic(1, .8)',
            }, '500')
            .add({
                targets: ".svg",
                zIndex: -1,
            }, 800)
    }, []);


    return (<>
        <div className="background" >
            <img src={process.env.PUBLIC_URL + "/assets/images/module3d/1.jpg"}
                alt="background"
                style={
                    { position: "absolute", left: 0, top: 0, width: 660 }}
            />

            <div
                style={{
                    position: "absolute",
                    left: 0,
                    top: 150,
                }}
                id="piano"
            >
                <img
                    style={{
                        position: "absolute",
                        left: 0,
                        top: 0,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/module3d/minikey.jpg"}
                ></img>
                <img
                    style={{
                        position: "absolute",
                        left: 0,
                        top: 0,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/module3d/note.jpg"}
                ></img>
                <svg
                    style={{
                        position: 'absolute',
                        top: '0px', left:
                            '10px', width: 650,
                        height: 81,
                        zIndex: 6
                    }}
                    onMouseEnter={() => setShowRect(true)}
                    onMouseLeave={() => setShowRect(false)}
                >
                    {/*cursor*/}
                    <line x1={cursorPos} y1="0" x2={cursorPos} y2="81" stroke="red" strokeWidth={2} />
                </svg>
                <img
                    src={
                        !musicPlaying ? process.env.PUBLIC_URL + "/assets/images/piano/play.svg" : process.env.PUBLIC_URL + "/assets/images/piano/play_clicked.svg"
                    }
                    alt="play"
                    onClick={play}
                    style={{ position: 'absolute', left: '10px', top: 93, zIndex: 8, cursor: "pointer" }} />

                <img
                    src={
                        musicPlaying ? process.env.PUBLIC_URL + "/assets/images/piano/pause.svg" : process.env.PUBLIC_URL + "/assets/images/piano/pause_clicked.svg"
                    }
                    alt="pause"
                    onClick={pause}
                    style={{ position: 'absolute', left: '30px', top: 93, zIndex: 8, cursor: "pointer" }} />

                <img
                    src={process.env.PUBLIC_URL + "/assets/images/piano/back.svg"}
                    alt="back"
                    onClick={reset}
                    style={{ position: 'absolute', left: '50px', top: 93, zIndex: 8, cursor: "pointer" }} />
            </div>

            <div
                style={{
                    position: "absolute",
                    left: 150,
                    top: 311,
                }}
                id="minipiano"
            >
                <img
                    style={{
                        position: "absolute",
                        left: 0,
                        top: 0,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/module3d/minikey.jpg"}
                ></img>
                <img
                    id="ImageMiniPiano"
                    style={{
                        position: "absolute",
                        left: 10,
                        top: 0,
                    }}
                    src={process.env.PUBLIC_URL + `/assets/images/module3d/${getChoix()}.png`}
                ></img>
                <svg style={{ position: 'absolute', top: '0px', left: '10px', width: 400, height: 81, zIndex: 6 }}>
                    {/*cursor*/}
                    <line x1={cursorPosMini} y1="0" x2={cursorPosMini} y2="81" stroke="red" strokeWidth={2} />
                </svg>
                <img
                    src={
                        !musicPlaying ? process.env.PUBLIC_URL + "/assets/images/piano/play.svg" : process.env.PUBLIC_URL + "/assets/images/piano/play_clicked.svg"
                    }
                    alt="play"
                    onClick={playMini}
                    style={{ position: 'absolute', left: '10px', top: 93, zIndex: 8, opacity: getChoix() == "choix0" ? 0.5 : 1, cursor: "pointer" }} />

                <img
                    src={process.env.PUBLIC_URL + "/assets/images/piano/back.svg"}
                    alt="back"
                    onClick={resetMini}
                    style={{ position: 'absolute', left: '30px', top: 93, zIndex: 8, opacity: getChoix() == "choix0" ? 0.5 : 1, cursor: "pointer" }} />
                <img
                    src={process.env.PUBLIC_URL + "/assets/images/module3d/4.png"}
                    alt="erase"
                    onClick={eraseMini}
                    style={{ position: 'absolute', left: '55px', width: "16px", top: 93, zIndex: 8, display: getChoix() == "choix0" ? "none" : "block", cursor: "pointer" }} />
                <img
                    src={process.env.PUBLIC_URL + "/assets/images/module3d/5.png"}
                    alt="back"
                    onClick={backMini}
                    style={{ position: 'absolute', left: '78px', width: "16px", top: 93, zIndex: 8, display: getChoix() == "choix0" ? "none" : "block", cursor: "pointer" }} />
            </div>

            {/* choice boxes */}
            <div
                style={{
                    position: 'absolute',
                    top: '163px',
                    left: '481px',
                    width: "80px",
                    height: "32px",
                    border: "1px solid black",
                    zIndex: 10,
                    display: currentChoices.length == 0 && showRect ? "block" : "none",
                    backgroundColor: "rgba(235, 194, 99, 0.3)"
                }}
                onMouseEnter={
                    (e) => {
                        e.target.style.backgroundColor = "rgba(252, 166, 53, 0.6)";
                        setShowRect(true)
                    }
                }
                onMouseLeave={
                    (e) => {
                        e.target.style.backgroundColor = "rgba(235, 194, 99, 0.3)"
                    }
                }
                onClick={
                    () => {
                        let currentChoicesCopy = [...currentChoices]
                        currentChoicesCopy.push(1)
                        setCurrentChoices(currentChoicesCopy)
                    }
                }
            />

            <div
                style={{
                    position: 'absolute',
                    top: '156px',
                    left: '576px',
                    width: "80px",
                    height: "36px",
                    border: "1px solid black",
                    zIndex: 10,
                    display: currentChoices.length == 0 && showRect ? "block" : "none",
                    backgroundColor: "rgba(235, 194, 99, 0.3)"
                }}
                onMouseEnter={
                    (e) => {
                        e.target.style.backgroundColor = "rgba(252, 166, 53, 0.6)"
                        setShowRect(true)
                    }
                }
                onMouseLeave={
                    (e) => {
                        e.target.style.backgroundColor = "rgba(235, 194, 99, 0.3)"
                    }
                }
                onClick={
                    () => {
                        let currentChoicesCopy = [...currentChoices]
                        currentChoicesCopy.push(2)
                        setCurrentChoices(currentChoicesCopy)
                    }
                }
            />

            <div
                style={{
                    position: 'absolute',
                    top: '165px',
                    left: '44px',
                    width: "117px",
                    height: "52px",
                    border: "1px solid black",
                    zIndex: 10,
                    display: currentChoices.length == 1 && showRect ? "block" : "none",
                    backgroundColor: "rgba(235, 194, 99, 0.3)"
                }}
                onMouseEnter={
                    (e) => {
                        e.target.style.backgroundColor = "rgba(252, 166, 53, 0.6)"
                        setShowRect(true)
                    }
                }
                onMouseLeave={
                    (e) => {
                        e.target.style.backgroundColor = "rgba(235, 194, 99, 0.3)"
                    }
                }
                onClick={
                    () => {
                        let currentChoicesCopy = [...currentChoices]
                        currentChoicesCopy.push(1)
                        setCurrentChoices(currentChoicesCopy)
                    }
                }
            />


            <div
                style={{
                    position: 'absolute',
                    top: '165px',
                    left: '264px',
                    width: "54px",
                    height: "43px",
                    border: "1px solid black",
                    zIndex: 10,
                    display: (currentChoices.length == 2 && currentChoices[0] == "1" && showRect) ? "block" : "none",
                    backgroundColor: "rgba(235, 194, 99, 0.3)"
                }}
                onMouseEnter={
                    (e) => {
                        e.target.style.backgroundColor = "rgba(252, 166, 53, 0.6)"
                        setShowRect(true)
                    }
                }
                onMouseLeave={
                    (e) => {
                        e.target.style.backgroundColor = "rgba(235, 194, 99, 0.3)"
                    }
                }
                onClick={
                    () => {
                        let currentChoicesCopy = [...currentChoices]
                        currentChoicesCopy.push(1)
                        setCurrentChoices(currentChoicesCopy)
                    }
                }
            />

            <div
                style={{
                    position: 'absolute',
                    top: '173px',
                    left: '303px',
                    width: "91px",
                    height: "45px",
                    border: "1px solid black",
                    zIndex: 10,
                    display: (currentChoices.length == 2 && currentChoices[0] == "1" && showRect) ? "block" : "none",
                    backgroundColor: "rgba(235, 194, 99, 0.3)"
                }}
                onMouseEnter={
                    (e) => {
                        e.target.style.backgroundColor = "rgba(252, 166, 53, 0.6)"
                        setShowRect(true)
                    }
                }
                onMouseLeave={
                    (e) => {
                        e.target.style.backgroundColor = "rgba(235, 194, 99, 0.3)"
                    }
                }
                onClick={
                    () => {
                        let currentChoicesCopy = [...currentChoices]
                        currentChoicesCopy.push(2)
                        setCurrentChoices(currentChoicesCopy)
                    }
                }
            />

            <div
                style={{
                    position: 'absolute',
                    top: '165px',
                    left: '264px',
                    width: "54px",
                    height: "43px",
                    border: "1px solid black",
                    zIndex: 10,
                    display: (currentChoices.length == 3 && currentChoices[0] == "1" && currentChoices[2] == "1" && showRect) ? "block" : "none",
                    backgroundColor: "rgba(235, 194, 99, 0.3)"
                }}
                onMouseEnter={
                    (e) => {
                        e.target.style.backgroundColor = "rgba(252, 166, 53, 0.6)"
                        setShowRect(true)
                    }
                }
                onMouseLeave={
                    (e) => {
                        e.target.style.backgroundColor = "rgba(235, 194, 99, 0.3)"
                    }
                }
                onClick={
                    () => {
                        let currentChoicesCopy = [...currentChoices]
                        currentChoicesCopy.push(1)
                        setCurrentChoices(currentChoicesCopy)
                    }
                }
            />

            <svg viewBox="0 0 660 500"
                className='svg'
                style={{
                    zIndex: 20,
                }}
            >
                <mask id="circles"
                    maskUnits="objectBoundingBox" >
                    <rect x="0"
                        y="0"
                        width="100%"
                        height="100%"
                        fill="white" />
                    <circle id="circle1"
                        cx="598"
                        cy="90"
                        r="0"
                        fill="black" />
                    <circle id="circle2"
                        cx="160"
                        cy="90"
                        r="0"
                        fill="black" />
                </mask>
                <rect x="0"
                    y="0"
                    width="100%"
                    height="100%"
                    fill="black"
                    style={
                        { mask: 'url(#circles)' }}
                />
            </svg>

            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 10,
                    top: 0,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>
            <p
                style={{
                    position: 'absolute',
                    left: 20,
                    top: 406,
                    width: 631,
                    color: 'white',
                    fontSize: '14px',
                    zIndex: 13
                }}
            >{texts.lang30}</p>
        </div >
    </>
    );
}

export default Module3d;